import type { GetBrandDTO } from "@nlc/shared-types";

import {
  keepPreviousData,
  useQuery,
  type UseQueryResult,
} from "@tanstack/react-query";

import { getBrandById } from "@/hooks/queryKeys";
import apiClient from "@/lib/api/client";

export function useGetBrandById(
  brandId: number,
  options?: { pollWhileExtracting?: boolean },
): UseQueryResult<GetBrandDTO> {
  return useQuery<GetBrandDTO>({
    enabled: brandId > 0,
    placeholderData: keepPreviousData,
    queryFn: async () =>
      apiClient.url(`/brands/${brandId}`).get().json<GetBrandDTO>(),
    queryKey: getBrandById.getBrandById(brandId),
    refetchInterval: options?.pollWhileExtracting
      ? (query) => {
          const data = query.state.data;

          if (!data) return 5000;
          const status = data.analysisStatus;

          if (!status) return false;
          if (status === "completed" || status === "failed") return false;

          return 5000;
        }
      : false,
    refetchIntervalInBackground: true,
    refetchOnWindowFocus: false,
    staleTime: options?.pollWhileExtracting ? 0 : 30_000,
  });
}
